module.exports = __webpack_public_path__ + "static/media/46_tn.23141d4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/46_tn.jpg
// module id = 259
// module chunks = 0